<template>
  <div class="main-page">
    <template v-if="showHeader">
      <section class="page-section mb-3 mb-3">
        <div class="container">
          <div class="grid justify-content-between">
            <div class="col-12 md:col-8">
              <div class="">
                <div class="flex align-items-center">
                  <div class="ml-2">
                    <div class="text-2xl text-primary font-bold">
                      User registration
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 md:col-4 comp-grid">
              <div class="">
                <div class="flex align-items-center">
                  <div>Already have an account?</div>
                  <div class="ml-2">
                    <router-link to="/">
                      <Button icon="pi pi-user" label="Login" />
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </template>
    <section class="page-section">
      <div class="container">
        <div class="grid">
          <div class="md:col-9 sm:col-12 comp-grid">
            <div class="card nice-shadow-18">
              <div>
                <form
                  ref="observer"
                  tag="form"
                  @submit.prevent="startSaveRecord()"
                  @reset="resetForm"
                >
                  <div class="grid">
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">Username *</div>
                        <div class="col-12 md:col-9">
                          <check-duplicate
                            v-model="formData.username"
                            check-path="components_data/institution_accounts_username_exist/"
                            v-slot="checker"
                          >
                            <InputText
                              ref="ctrlusername"
                              @blur="checker.check"
                              :loading="checker.loading"
                              v-model.trim="formData.username"
                              label="Username"
                              type="text"
                              placeholder="Enter Username"
                              class="w-full"
                              :class="getErrorClass('username')"
                            >
                            </InputText>
                            <small
                              v-if="!checker.loading && checker.exist"
                              class="p-error"
                            >
                              Not available</small
                            >
                            <small v-if="checker.loading" class="text-500"
                              >Checking...</small
                            >
                          </check-duplicate>
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">Email *</div>
                        <div class="col-12 md:col-9">
                          <check-duplicate
                            v-model="formData.email"
                            check-path="components_data/institution_accounts_email_exist/"
                            v-slot="checker"
                          >
                            <InputText
                              ref="ctrlemail"
                              @blur="checker.check"
                              :loading="checker.loading"
                              v-model.trim="formData.email"
                              label="Email"
                              type="email"
                              placeholder="Enter Email"
                              class="w-full"
                              :class="getErrorClass('email')"
                            >
                            </InputText>
                            <small
                              v-if="!checker.loading && checker.exist"
                              class="p-error"
                            >
                              Not available</small
                            >
                            <small v-if="checker.loading" class="text-500"
                              >Checking...</small
                            >
                          </check-duplicate>
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">Password *</div>
                        <div class="col-12 md:col-9">
                          <Password
                            ref="ctrlpassword"
                            v-model="formData.password"
                            label="Password"
                            placeholder="Enter Password"
                            class="w-full"
                            inputClass="w-full"
                            toggleMask
                            :feedback="true"
                            :class="getErrorClass('password')"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">Confirm Password *</div>
                        <div class="col-12 md:col-9">
                          <Password
                            class="w-full"
                            :class="getErrorClass('password')"
                            inputClass="w-full"
                            :feedback="false"
                            toggleMask
                            ref="ctrlconfirmpassword"
                            v-model="formData.confirm_password"
                            label="Confirm Password"
                            placeholder="Confirm Password"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="formgrid grid">
                        <div class="col-12 md:col-3">Profile Photo</div>
                        <div class="col-12 md:col-9">
                          <div class="mb-3">
                            <Uploader
                              :class="getErrorClass('profile_photo')"
                              upload-path="fileuploader/upload/profile_photo"
                              v-model="formData.profile_photo"
                              :fileLimit="1"
                              :maxFileSize="3000000"
                              accept=".jpg,.png,.gif,.jpeg"
                              :multiple="false"
                              label="Choose files or drop files here"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-if="showSubmitButton" class="text-center my-3">
                    <Button
                      type="submit"
                      label="Submit"
                      icon="pi pi-send"
                      :loading="saving"
                    />
                  </div>
                </form>
                <slot :submit="submit" :saving="saving"></slot>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import { PageMixin } from "../../mixins/page.js";
import { AddPageMixin } from "../../mixins/addpage.js";
import { mapActions, mapGetters, mapState } from "vuex";
import useVuelidate from "@vuelidate/core";
import { required, email, sameAs } from "@vuelidate/validators";
export default {
  setup() {
    return { v$: useVuelidate() };
  },
  name: "RegisterComponent",
  components: {},
  mixins: [PageMixin, AddPageMixin],
  props: {
    pageName: {
      type: String,
      default: "institution_accounts",
    },
    routeName: {
      type: String,
      default: "institution_accountsuserregister",
    },
    apiPath: {
      type: String,
      default: "auth/register",
    },
  },
  data() {
    return {
      formData: {
        username: "",
        email: "",
        password: "",
        confirm_password: "",
        profile_photo: "",
      },
    };
  },
  computed: {
    pageTitle: {
      get: function () {
        return "Add New Institution Accounts";
      },
    },
  },
  validations() {
    let formData = {
      username: { required },
      email: { required, email },
      password: { required },
      confirm_password: { sameAsPassword: sameAs(this.formData.password) },
      profile_photo: {},
    };
    return { formData };
  },
  meta() {
    return {
      title: this.pageTitle,
    };
  },
  methods: {
    ...mapActions("institution_accounts", ["saveRecord"]),
    async startSaveRecord() {
      this.submitted = true;
      const isFormValid = !this.v$.$invalid;
      if (!isFormValid) {
        this.flashMsg("Form is invalid", "", "error");
        return;
      }
      this.saving = true;
      let payload = this.normalizedFormData();
      let url = this.apiUrl;
      let data = { url, payload };
      this.saveRecord(data).then(
        (response) => {
          this.saving = false;
          this.resetForm();
          let registrationData = response.data;
          if (registrationData.token && registrationData.user) {
            this.$localStore.saveLoginData(registrationData, false);
            location.href = "/"; //reload page and navigation to home page
          } else {
            this.flashMsg(registrationData.message);
            this.navigateTo(registrationData.nextpage);
          }
        },
        (response) => {
          this.saving = false;
          this.showPageRequestError(response);
        }
      );
    },
    resetForm() {
      this.formData = {
        username: "",
        email: "",
        password: "",
        confirm_password: "",
        profile_photo: "",
      };
      requestAnimationFrame(() => {
        this.$refs.observer.reset();
      });
      //this.$EventBus.$emit("resetForm");
    },
    getErrorClass(field) {
      return {
        "p-invalid": this.v$.formData[field].$invalid && this.submitted,
      };
    },
  },
  async mounted() {},
  async created() {},
};
</script>
<style scoped></style>
